import { LandingNotices } from './LandingNotices.js'
import { LandingUploadVisual } from './LandingUploadVisual.js'
import { TryFreeButton } from './TryFreeButton.js'

type LandingHeroProps = {
  loading: boolean
  error: string | null
  migratedNotice: boolean
  onTryFree: () => void
}

export function LandingHero({ loading, error, migratedNotice, onTryFree }: LandingHeroProps) {
  return (
    <section className="relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(circle_at_18%_12%,hsl(var(--accent))_0%,hsl(var(--background))_48%,hsl(var(--background))_100%)]"
      />
      <div aria-hidden className="absolute inset-0 grain opacity-60 pointer-events-none" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-4 py-16 sm:px-6 sm:py-24 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
        <div className="text-center lg:text-left">
          <p className="landing-fade-in inline-flex items-center gap-2 rounded-full border border-primary/15 bg-white/80 px-4 py-2 text-xs font-semibold text-accent-foreground shadow-sm">
            <span className="size-1.5 rounded-full bg-primary" />
            アダルト事業者のためのファイル共有
          </p>
          <h2 className="landing-fade-in landing-fade-in-delay-1 mt-7 font-bold tracking-tight leading-[1.08] text-[2.35rem] sm:text-5xl lg:text-[3.65rem]">
            <span className="block bg-gradient-primary bg-clip-text text-transparent">
              絶対BANされない
            </span>
            <span className="mt-2 block bg-gradient-primary bg-clip-text text-transparent">
              爆速アップロード
            </span>
          </h2>
          <p className="landing-fade-in landing-fade-in-delay-2 mx-auto mt-7 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg lg:mx-0">
            動画の内容を理由に、アカウントを止めることはありません。
            <br className="hidden sm:block" />
            容量の大きな動画も、待たずに送れます。
          </p>
          <div className="landing-fade-in landing-fade-in-delay-3 mt-9 space-y-3">
            <TryFreeButton loading={loading} onTryFree={onTryFree} />
            <p className="text-xs text-muted-foreground">24時間、登録なしで使えます。</p>
          </div>
          <LandingNotices error={error} migratedNotice={migratedNotice} />
        </div>
        <LandingUploadVisual />
      </div>
    </section>
  )
}
